(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TeamManagementDetailController', TeamManagementDetailController);

    TeamManagementDetailController.$inject = ['$stateParams', 'Team'];

    function TeamManagementDetailController ($stateParams, Team) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            Team.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();
